import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home, NewContent } from './pages';
import { MainLayout } from './components/layout/MainLayout/MainLayout';

interface AppRoutesProps {
  onThemeToggle: () => void;
  isDark: boolean;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ onThemeToggle, isDark }) => {
  return (
    <Routes>
      <Route element={<MainLayout onThemeToggle={onThemeToggle} isDark={isDark} />}>
        <Route path="/" element={<Home />} />
        <Route path="/new-content" element={<NewContent isDark={isDark} />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
